import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWatermarkPdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#1BCFC4" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17 10.667V6.4c0-.373 0-.56-.068-.703a.65.65 0 0 0-.273-.291c-.134-.073-.309-.073-.659-.073H8c-.35 0-.525 0-.659.073a.65.65 0 0 0-.273.291C7 5.84 7 6.027 7 6.4v4.267m10 0H7m10 0v.133c0 1.12 0 1.68-.204 2.108-.18.376-.467.682-.82.874C15.576 14 15.05 14 14 14h-4c-1.05 0-1.575 0-1.976-.218a1.94 1.94 0 0 1-.82-.874C7 12.48 7 11.92 7 10.8v-.133M13.563 14v3c0 .92-.7 1.667-1.563 1.667S10.438 17.92 10.438 17v-3"
    />
  </svg>
);
export default SvgWatermarkPdf;
